import { render, staticRenderFns } from "./InnovationView.vue?vue&type=template&id=013bf763&scoped=true"
import script from "./InnovationView.vue?vue&type=script&lang=js"
export * from "./InnovationView.vue?vue&type=script&lang=js"
import style0 from "./InnovationView.vue?vue&type=style&index=0&id=013bf763&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013bf763",
  null
  
)

export default component.exports